
import { mapState, mapMutations } from "vuex";
import CurrencyConverter from "../common/currency-converter.vue";
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  components: { ResponsiveDialog, CurrencyConverter },
  props: {
    dialog: Boolean,
    selectedPackagingCharge: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      selectAll: false,
      selectedItems: []
    };
  },
  computed: {
    ...mapState("menu", ["menuUploadList"])
  },
  methods: {
    ...mapMutations("menu", ["SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP"]),

    isEligible(item) {
      return this.selectedPackagingCharge <= this.getApplicableMaxCharge(item);
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedItems = this.menuUploadList
          .filter((item) => this.isEligible(item))
          .map((item) => item.id);
      } else {
        this.selectedItems = [];
      }
    },

    submitSelection() {
      this.selectedItems.forEach((itemId) => {
        const index = this.getMenuUploadItemIndex(this.menuUploadList, itemId);

        if (index !== -1) {
          this.SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP({
            index: index,
            propName: "package_charge",
            propValue: this.selectedPackagingCharge
          });
        }
      });

      this.$emit("close-dialog");
    }
  }
};
